function replaceSpecialChars(str){
    str = str.replace(/[ÀÁÂÃ]/,"A");
    str = str.replace(/[àáâã]/,"a");
    str = str.replace(/[ÈÉÊẼ]/,"E");
    str = str.replace(/[èéêẽ]/,"e");
    str = str.replace(/[ÌÍÎĨ]/,"I");
    str = str.replace(/[ìíîĩ]/,"i");
    str = str.replace(/[ÒÓÔÕ]/,"O");
    str = str.replace(/[òóôõ]/,"o");
    str = str.replace(/[ÙÚÛŨ]/,"U");
    str = str.replace(/[ùúûũ]/,"u");
    str = str.replace(/[Ç]/,"C");
    str = str.replace(/[ç]/,"c");

    return str.replace(/[^a-z0-9]/gi,''); 
}

let mutations = {
    FETCH_RESTAURANT(state, restaurant){
        state.restaurant = restaurant
        return 
    },
    SET_UTIL(state,util){
        return state.util = util
    },
    SET_COMMON(state,common){
        return state.common = common
    },
    SET_TYPE(state,typeSelected){
        return state.typeSelected = typeSelected
    },
    SET_SUBTYPES(state,subtypes){
        return state.subtypes = subtypes
    },
    FETCH_PRODUCTS(state, payload){
        return state.products = Object.assign(state.products,payload)
    },
    SET_PAGINATION(state, payload){
        return state.products = Object.assign(state.products,payload)
    },
    FETCH_PRODUCT(state,product){
        return state.product = product
    },
    FETCH_MULTI_PRODUCTS(state,multiProducts){
        return state.multiProducts = multiProducts
    },
    FETCH_PIZZA(state,pizza){
        pizza.tamanhos = Object.values(pizza.tamanhos)
        return state.pizza = pizza
    },
    FETCH_SIZES(state,sizes){
        return state.sizes = sizes
    },
    FETCH_TYPE(state,type){
        return state.type = type
    },
    FETCH_MENU(state,menu){
        return state.menu = menu
    },
    FETCH_USER(state, user){
        localStorage.setItem('user',JSON.stringify(user))
        localStorage.setItem('restaurant_id',user.restaurant)
        state.restaurant_id = user.restaurant
        return state.user = user
    },
    FETCH_MY_ORDERS(state, myOrders){
        return state.myOrders = myOrders
    },
    FETCH_MY_ORDER(state,myOrder){
        return state.myOrder = myOrder
    },
    PHONE_VALIDATION(state,phone_validation){
        return state.phone_validation = phone_validation
    },
    SET_TOKEN(state,token){
        localStorage.setItem('token',token)
        return state.token = token
    },
    SET_ADDRESS(state, address){
        let data = {
            cep:address.address_cep,
            city:address.address_city,
            street:address.address_street,
            number:address.address_number,
            cmplt:address.address_cmplt,
            district:address.address_district,
            state:address.address_state,
            location:address.address_location,
            default:address.address_default
        }
        return state.address = data
    },
    LOGOUT(state){
        localStorage.clear()
        state.token = null
        state.restaurant = null
        return state.user = null
    },
    SET_AUTH_ERROR(state, authError){
        return state.authError = authError
    },
    SET_CONNECTION_ERROR(state, connectionError){
        return state.connectionError = connectionError
    },
    FETCH_CART(state, cart){
        localStorage.setItem('cart',JSON.stringify(cart))
        return state.cart = cart
    },
    SET_AGENDAMENTO(state,agendamento){
        localStorage.setItem('agendamento',JSON.stringify(agendamento))
        return state.agendamento = agendamento
    },
    SET_COUPON(state, coupon){
        if(!coupon || coupon == ''){
            localStorage.removeItem('coupon')    
        }else{
            localStorage.setItem('coupon',coupon)
        }
        return state.coupon = coupon
    },
    ADD_TO_CART_PRODUCTS(state, {cartProduct}){
        //adicionar no carrinho
        state.cartProducts.push(cartProduct)
        localStorage.setItem('cartProducts',JSON.stringify(state.cartProducts))
        return
    },
    CHANGE_QUANT_PRODUCT(state,{index,q}){
        if(q <= 0){
            state.cartProducts.splice(index,1)
            localStorage.setItem('cartProducts',JSON.stringify(state.cartProducts))
            return state.cart.products.splice(index,1)    
        }else{
            let p = state.cart.products[index]
            p.quantity = q
            return state.cart.products.splice(index,1,p)
        }
    },
    PENDING_ORDER(state, pendingOrder){
        state.pendingOrderId = pendingOrder._id
        localStorage.setItem('pendingOrderId',pendingOrder._id)
        return state.pendingOrder = pendingOrder
    },
    CLEAR_CART(state){
        localStorage.removeItem('cart')
        localStorage.removeItem('coupon')
        localStorage.removeItem('agendamento')
        return state.cart = null
    },
    CLEAR_ORDER(state){
        return state.order = null
    },
    CLEAR_CART_PRODUCTS(state){
        localStorage.removeItem('cartProducts')
        return state.cartProducts = []  
    },
    TOGGLE_DRAWER(state){
        return state.drawer = !state.drawer 
    },
    TOGGLE_LOGIN_DIALOG(state){
        return state.loginDialog = !state.loginDialog
    },
    TOGGLE_REGISTER_DIALOG(state){
        return state.registerDialog = !state.registerDialog
    },
    TOGGLE_ADDRESS_DIALOG(state){
        return state.addressDialog = !state.addressDialog
    },
    TOGGLE_SET_ADDRESS_DIALOG(state){
        return state.setAddressDialog = !state.setAddressDialog
    },
    TOGGLE_UPDATE_USER_DIALOG(state){
        return state.updateUserDialog = !state.updateUserDialog
    },
    TOGGLE_SMS_PASSWORD_DIALOG(state){
        return state.smsPasswordDialog = !state.smsPasswordDialog
    },
    TOGGLE_RESET_PASSWORD_DIALOG(state){
        return state.resetPasswordDialog = !state.resetPasswordDialog
    },
    TOGGLE_PRODUCT_DIALOG(state){
        return state.productDialog = !state.productDialog
    },
    TOGGLE_TYPE_DIALOG(state){
        return state.typeDialog = !state.typeDialog
    },
    TOGGLE_SUBTYPES(state){
        return state.subtypes = !state.subtypes
    },
    SET_FILTER(state,filter){
        return state.filter = filter
    },
    SET_SUBTYPE(state,subtype){
        return state.subtype = subtype
    },
    CLEAR_RESPONSE(state){
        return state.response = null
    },
    SET_TAGS(state, tags){
        return state.tags = tags
    },
    SET_STATES(state, states){
        return state.states = states
    },
    SET_CITIES(state, payload){
        const cities = []
        payload.forEach(v=>{
            cities.push({
                _id:v._id,
                value:replaceSpecialChars(v.nome),
                nome:v.nome
            })
        })
        return state.cities = cities
    },
    SET_PAYMENTS(state,payments){
        return state.payments = payments
    },
    IS_CLEAN_PAGE(state,isCleanPage){
        return state.isCleanPage = isCleanPage
    }
}

export default mutations